module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web35.b5ef69bd.jpg";